import {
	SET_AVAILABLE_ASSETS,
	SHOW_ERROR_MESSAGE,
	SHOW_SUCCESS_MESSAGE,
	HIDE_TOAST_MESSAGE
} from "./FrequencyTrendLimitConfigurationActionsType";
import ToastMessageType from "@/constants/enums/ToastMessageType";
import { RESET_STATE } from "@/stores/CommumActionTypes";
import FrequencyLimitsFactory from "../factories/FrequencyLimitsFactory";

const mutations = {
	[SET_AVAILABLE_ASSETS](state, assets)
	{
		state.availableAssets = assets;
	},
	[SHOW_ERROR_MESSAGE](state, message)
	{
		state.toast.type = ToastMessageType.ERROR;
		state.toast.message = message;
		state.toast.show = true;
	},
	[SHOW_SUCCESS_MESSAGE](state, message)
	{
		state.toast.type = ToastMessageType.SUCCESS;
		state.toast.message = message;
		state.toast.show = true;
	},
	[HIDE_TOAST_MESSAGE](state)
	{
		state.toast.show = false;
	},
	[RESET_STATE](state)
	{
		Object.assign(state, FrequencyLimitsFactory.EmptyState());
	}
};

export default { mutations };